import { filterProductsWithSlab, getProductPriceSlabs } from "./searchUtils";
import { formatManufacturerName } from "./stringUtils";
import { capitalizeStr } from "./helper";
import { getSlabUnitPrice } from "./bomToolUtils";

const getNumericAvailability = (value) => {
  if (value === null || value === undefined) return 0;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

// Group the products by part number and quantity
export const getGroupedProducts = (productArray, processedBom) => {
  const groups = [...new Set(productArray.map((item) => item.part_number))];

  // console.log({ productArray, processedBom, groups });

  const groupArray = [];

  // Create a list of unique part numbers and quantities
  let uniquePartNumbersList = [];
  for (let i = 0; i < processedBom.length; i++) {
    let uniquePartNumbers = [];
    uniquePartNumbers["mpn"] = processedBom[i].part_number;
    uniquePartNumbers["qty"] = processedBom[i].qty;
    uniquePartNumbersList = [...uniquePartNumbersList, uniquePartNumbers];
  }

  // console.log({ uniquePartNumbersList });

  // Loop through the unique part numbers and quantities
  for (let j = 0; j < uniquePartNumbersList.length; j++) {
    let productAvalability = 0;
    const requiredQty = parseInt(uniquePartNumbersList[j].qty, 10);

    // Helper function to check if availability is valid (not empty, 0, "0", or "None")
    const isValidAvailability = (availability) => {
      if (availability === null || availability === undefined) return false;
      if (availability == "" || availability == "None" || availability == "0" || availability === 0)
        return false;
      const numAvailability = getNumericAvailability(availability);
      return numAvailability > 0;
    };

    // Filter products with valid availability (not "", 0, "0", or "None")
    // This includes products with partial availability (availability < required qty)
    const groupProducts = productArray?.filter(
      (product) =>
        product.part_number.toLowerCase() == uniquePartNumbersList[j].mpn.toLowerCase() &&
        product.qty == uniquePartNumbersList[j].qty &&
        isValidAvailability(product.availability),
    );

    // console.log({ groupProducts });

    const filteredProducts = filterProductsWithSlab({
      products: groupProducts,
    });

    // console.log({ filteredProducts, groupProducts });

    const proNotAvailable = productArray?.filter(
      (product) =>
        product.part_number.toLowerCase() === uniquePartNumbersList[j].mpn.toLowerCase() &&
        product.qty == uniquePartNumbersList[j].qty &&
        !isValidAvailability(product.availability),
    );

    const productResArray = productArray?.filter(
      (product) =>
        product.part_number.toLowerCase() === uniquePartNumbersList[j].mpn.toLowerCase() &&
        product.qty == uniquePartNumbersList[j].qty,
    );

    if (
      proNotAvailable.length == productResArray.length &&
      groups.find((group) => group.toLowerCase() === uniquePartNumbersList[j].mpn.toLowerCase())
    ) {
      productAvalability = 0;
    }

    if (filteredProducts.length > 0) productAvalability = filteredProducts[0].availability;

    // Calculate backorder quantity if availability is less than required quantity
    let backorderQty = 0;
    if (productAvalability > 0 && productAvalability < requiredQty) {
      backorderQty = requiredQty - productAvalability;
    }

    const groupData = {
      name: uniquePartNumbersList[j].mpn,
      priceSlabs: getProductPriceSlabs(filteredProducts),
      products: filteredProducts,
      availability: productAvalability,
      backorderQty: backorderQty,
      requiredQty: requiredQty,
    };
    groupArray.push(groupData);
  }

  // console.log({ groups, groupArray });

  return groupArray;
};

export const distributorSummary = (sortProArr, distributorMinimumPrice) => {
  if (!sortProArr || !distributorMinimumPrice) return [];
  const DistributorListArr = sortProArr.map(function (value) {
    return value.api_partner;
  });
  const uniqueDistributorListArr = [...new Set(DistributorListArr)];
  let distributorSummaryListArr = [];
  for (let i = 0; i < uniqueDistributorListArr.length; i++) {
    let distributorSummary = [];
    distributorSummary["minBomTotal"] = "";
    distributorSummary["distributor"] = uniqueDistributorListArr[i];
    distributorSummary["totalPrice"] = 0;
    distributorSummary["distributorItemCount"] = 0;
    for (let j = 0; j < sortProArr.length; j++) {
      if (uniqueDistributorListArr[i] == sortProArr[j].api_partner) {
        distributorSummary["totalPrice"] += sortProArr[j].totalPrice;
        distributorSummary["distributorItemCount"]++;
      }
    }
    let distributorMinBomTot = distributorMinimumPrice?.filter(
      (distributor) =>
        distributor.name.toLowerCase() == distributorSummary["distributor"].toLowerCase(),
    );
    if (distributorMinBomTot.length > 0) {
      // console.log({ distributor: distributorSummary["distributor"], distributorMinBomTot: distributorMinBomTot });

      let minBomTotal = distributorMinBomTot.map((item) => item.minBomTotal);
      distributorSummary["minBomTotal"] = minBomTotal[0];
    }
    distributorSummaryListArr = [...distributorSummaryListArr, distributorSummary];
  }
  return distributorSummaryListArr;
};

export const getNextSlabPrice = (product) => {
  let matchingPriceSlab = null;
  let nextSlabIndex, matchingSlabPrice;
  let nextPriceSlab = {
    nextSlabFlag: false,
    nextSlabQty: 0,
    nextSlabAmount: 0,
  };
  for (let i = 0; i < product.price.price_list.length; i++) {
    const slab = product.price.price_list[i];
    if (slab.min_qty <= product.qty) {
      matchingPriceSlab = slab;
      matchingSlabPrice = slab.price * product.qty;
      nextSlabIndex = i + 1;
    }
  }
  if (product.price.price_list.length > 1 && product.price.price_list.length > nextSlabIndex + 1) {
    let nextPrice = product.price.price_list[nextSlabIndex];
    console.log({
      NextSlab_matchingSlabPrice: matchingSlabPrice,
      NextSlab_nextPriceSlab: nextPrice.price,
    });
    if (matchingSlabPrice >= nextPrice.price * nextPrice.min_qty) {
      nextPriceSlab = {
        nextSlabFlag: true,
        nextSlabQty: nextPrice.min_qty,
        nextSlabAmount: nextPrice.price,
      };
    }
  }
  return nextPriceSlab;
};

export const findLowest = (uniquePartNumbersList, productArr) => {
  // console.log({ uniquePartNumbersList, productArr });
  let sortProArr = [];
  let sortProduct = [];
  let onTotalPrice = 0;
  let lowestIndex = 0;

  // Get all unique part numbers from productArr
  const uniquePartNumbersFromProducts = [
    ...new Set(productArr.map((product) => product.part_number?.toLowerCase())),
  ].filter((pn) => pn); // Filter out undefined/null values

  // Iterate through each unique part number from productArr
  for (let i = 0; i < uniquePartNumbersFromProducts.length; i++) {
    const currentPartNumber = uniquePartNumbersFromProducts[i];

    // Find the required quantity for this part number from uniquePartNumbersList
    const requiredPart = uniquePartNumbersList.find(
      (req) => req.mpn?.toLowerCase() === currentPartNumber,
    );

    // Only process if this part number is in the required list
    if (!requiredPart) {
      continue;
    }

    const requiredQty = parseInt(requiredPart.qty, 10);
    let Lowest = 0;
    let Lowestflag = false;
    lowestIndex = 0;

    // Find all products matching this part number and quantity
    for (let j = 0; j < productArr.length; j++) {
      const productPartNumber = productArr[j]?.part_number?.toLowerCase();
      const productQty = parseInt(productArr[j]?.qty, 10);
      if (
        productPartNumber === currentPartNumber &&
        productQty === requiredQty &&
        productArr[j]?.selectedPrice
      ) {
        Lowestflag = true;
        const price = getSlabUnitPrice(productArr[j]?.selectedPrice);

        if (Lowest == 0) {
          Lowest = price;
          lowestIndex = j;
          onTotalPrice = requiredQty * price;
        } else if (price <= Lowest) {
          lowestIndex = j;
          Lowest = price;
          onTotalPrice = requiredQty * price;
        }
      }
    }

    if (Lowestflag) {
      sortProduct = {
        ...productArr[lowestIndex],
        totalPrice: onTotalPrice,
      };
      sortProArr = [...sortProArr, sortProduct];
    }
  }

  // console.log({ sortProArr });
  return sortProArr;
};

export const processBomConsolidatedData = (groupData) => {
  const groupArray = [];
  const productsOriginalArray = [];

  for (let i = 0; i < groupData.length; i++) {
    let groupItem = {
      ...groupData[i],
    };
    productsOriginalArray.push(...groupItem.products);

    const products = [];
    for (let j = 0; j < groupItem.products.length; j++) {
      const availabilityCheck = getAvailabilityStatus(groupItem.products[j]);
      const priceSlabCheck = getPriceSlabStatus(groupItem.products[j]);

      // console.log({
      //   product: groupItem.products[j],
      //   availabilityCheck,
      //   priceSlabCheck,
      // });

      if (availabilityCheck && priceSlabCheck) {
        const product = groupItem.products[j];
        const availability = getNumericAvailability(product.availability);
        const requiredQty = parseInt(product.qty, 10);

        // Calculate backorder quantity if availability is less than required quantity
        const backorderQty = availability < requiredQty ? requiredQty - availability : 0;

        products.push({
          ...product,
          selectedPrice: priceSlabCheck,
          backorderQty: backorderQty,
        });
      }

      /* else {
         const defaultPrice =
           groupItem.products[j].price.price_list.length > 0
             ? groupItem.products[j].price.price_list[0]
             : null;
         if (defaultPrice)
           products.push({
             ...groupItem.products[j],
             selectedPrice: defaultPrice,
           });
       }*/
    }
    //selecting the next available qty line item if the RFQ is higher than the stock
    if (products.length == 0) {
      if (groupItem.products.length > 0) {
        const highestStrockProduct = groupItem.products.reduce((maxObject, currentObject) => {
          return currentObject.availability > maxObject.availability ? currentObject : maxObject;
        }, groupItem.products[0]);

        //matching slab calculation
        // console.log(highestStrockProduct);
        if (highestStrockProduct.price.price_list.length > 0) {
          //matching slab calculation
          // console.log({ highestStrockProduct: highestStrockProduct });

          let highestSlabIndex = highestStrockProduct.price.price_list.length - 1;
          let matchingPriceSlab = highestStrockProduct.price.price_list[highestSlabIndex];
          products.push({
            ...highestStrockProduct,
            selectedPrice: matchingPriceSlab,
          });
          // console.log({ highestProduct: products });
        }
      }
    }
    groupItem.products = products;
    groupArray.push(groupItem);
  }

  const productsArray = [];

  for (let i = 0; i < groupArray.length; i++) {
    productsArray.push(...groupArray[i].products);
  }

  return { productsArray, groupArray };
};

export const getPriceSlabStatus = (product) => {
  let matchingPriceSlab = null;

  for (let i = 0; i < product.price.price_list.length; i++) {
    const slab = product.price.price_list[i];
    // console.log({ min: slab.min_qty, condi: "<=", qty: product.qty });
    if (slab.min_qty <= product.qty) {
      matchingPriceSlab = slab;
    }
  }

  return matchingPriceSlab;
};

export const getAvailabilityStatus = (product) => {
  // Check if availability is valid (not "", 0, "0", or "None")
  if (
    product.availability === null ||
    product.availability === undefined ||
    product.availability === "" ||
    product.availability === "0" ||
    product.availability === "None"
  ) {
    return false;
  }

  const availability = getNumericAvailability(product.availability);
  const requiredQty = parseInt(product.qty, 10);

  // Return true if availability > 0 (even if less than required qty - partial availability is allowed)
  return availability > 0;
};

/**
 * Removes duplicate products by manufacturer, part_number, api_partner, hts_code, and qty.
 * Keeps the first occurrence of each unique combination.
 * @param {Array} products - Array of product objects
 * @returns {Array} Deduplicated array
 */
export const deduplicateByProductKeys = (products) => {
  if (!Array.isArray(products) || products.length === 0) return products;
  const seen = new Set();
  return products.filter((product) => {
    const key = [
      String(product.manufacturer ?? "").toLowerCase(),
      String(product.part_number ?? "").toLowerCase(),
      String(product.api_partner ?? "").toLowerCase(),
      // String(product.api_partner_part_number ?? "").toLowerCase(),
      String(product.hts_code ?? "").toLowerCase(),
      String(product.qty ?? ""),
    ].join("|");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/**
 * Build bomData shape from BOM status API response (same as BomToolPage onLoad).
 * Used for export when we only have the API response (e.g. UploadedBomPage download).
 */
export const buildBomDataFromApiResponse = (res) => {
  if (!res?.status || !res?.data?.bom_items?.length) return null;
  const mapQty = (array, qty) => array.map((item) => ({ ...item, qty }));
  const products = [];
  const multipleMPN = [];

  for (let i = 0; i < res.data.bom_items.length; i++) {
    const item = res.data.bom_items[i];
    const currentItemProducts = [];
    if (item.mouser) currentItemProducts.push(...mapQty(item.mouser, Number(item.qty)));
    if (item.digikey) currentItemProducts.push(...mapQty(item.digikey, Number(item.qty)));
    const exactMatch = currentItemProducts.filter((p) => p.MPNMatchFlag);
    if (exactMatch.length !== 0 && (item.digikeyCount > 0 || item.mouserCount > 0)) {
      multipleMPN.push(item.part_number);
    }
    products.push(...currentItemProducts);
  }

  const processedBom = res.data.bom_items.filter((bomItem) => bomItem.status == 2);
  const filteredMatchingProducts = products.filter((p) => p.MPNMatchFlag);
  const groupData = getGroupedProducts(filteredMatchingProducts, processedBom);
  const noStock = groupData?.filter((g) => g.availability == 0 || g.availability === "");
  const processedPartNo = products.map((p) => p.part_number);
  const allPartNo = processedBom.map((p) => p.part_number);
  const notFoundProduct = allPartNo.filter((pn) => !processedPartNo.includes(pn));

  return {
    groupData,
    processedBom,
    noStockCount: noStock ?? [],
    notFoundProduct,
    bomItems: res.data.bom_items,
    multipleMPN: multipleMPN ?? [],
  };
};

/**
 * Build { products, allProducts } from bomData for export (same as BomConsolidatedView onLoad with showLowest=true).
 */
export const buildAllForExport = (bomData) => {
  if (!bomData?.groupData?.length) return { products: [], allProducts: [] };
  const processedData = processBomConsolidatedData(bomData.groupData);
  const productsArray = processedData?.productsArray ?? [];
  const uniquePartNumbersList = (bomData.processedBom || []).map((bomItem) => ({
    mpn: bomItem.part_number,
    qty: bomItem.qty,
  }));
  const sortProArr = findLowest(uniquePartNumbersList, productsArray);
  const MPNNotInSortArray = uniquePartNumbersList.filter(
    (obj1) => !sortProArr.some((obj2) => obj2.part_number == obj1.mpn && obj2.qty == obj1.qty),
  );
  const ProArr = productsArray.filter(
    (item) => item.api_partner != "tme" && item.api_partner != "rutronik",
  );
  const SortedMPN = findLowest(MPNNotInSortArray, ProArr);
  const products = [...sortProArr, ...SortedMPN];
  return { products, allProducts: productsArray };
};

/**
 * Build export rows matching BomResultProcessingTable: one row per bomItem,
 * including "Stock not found", "No data found", and "No MPN found" status rows.
 */
export const getExportRowsFromBomItems = (bomData, all) => {
  if (!bomData?.bomItems?.length) return [];
  const rows = [];
  const products = all?.products || [];
  const allProducts = all?.allProducts || [];

  for (const item of bomData.bomItems) {
    const partLower = item.part_number?.toLowerCase();
    const processedPartCheck = products.find((p) => p.part_number?.toLowerCase() === partLower);
    const noDataCheck = bomData.notFoundProduct?.find((p) => p?.toLowerCase() === partLower);
    const noStockCheck = bomData.noStockCount?.find((p) => p?.name?.toLowerCase() === partLower);
    const groupDataCheck = bomData.groupData?.find((g) => g.name?.toLowerCase() === partLower);
    const multipleMPNCheck = bomData.multipleMPN?.find((m) => m?.toLowerCase() === partLower);

    const emptyCell = "";
    const sku = item.part_number ?? emptyCell;
    const qty = item.qty ?? emptyCell;

    if (processedPartCheck) {
      // When user selected a distributor, use that distributor's product data for the full row
      let p = processedPartCheck;
      if (item.selected_distributor && allProducts?.length) {
        const productForDistributor = allProducts.find(
          (product) =>
            product.part_number?.toLowerCase() === partLower &&
            capitalizeStr(product.api_partner)?.toLowerCase() ===
              item.selected_distributor?.toLowerCase(),
        );
        if (productForDistributor) {
          p = productForDistributor;
        }
      }
      const distributor = item.selected_distributor
        ? capitalizeStr(item.selected_distributor)
        : capitalizeStr(p.api_partner);
      rows.push([
        sku,
        formatManufacturerName(p.manufacturer),
        distributor,
        p.description ?? emptyCell,
        p.hts_code ?? emptyCell,
        p.date_code ?? emptyCell,
        p.qty ?? qty,
        p.availability ?? emptyCell,
        p.selectedPrice?.min_qty ?? emptyCell,
        p.price?.multiple ?? emptyCell,
        p.selectedPrice ? getSlabUnitPrice(p.selectedPrice) : emptyCell,
        emptyCell,
      ]);
      continue;
    }
    if (noStockCheck && !multipleMPNCheck) {
      rows.push([
        sku,
        "Stock not found",
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        qty,
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        "Stock not found",
      ]);
      continue;
    }
    if (noDataCheck && !noStockCheck && !multipleMPNCheck) {
      rows.push([
        sku,
        "No data found",
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        qty,
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        "No data found",
      ]);
      continue;
    }
    if (groupDataCheck && !noStockCheck && !noDataCheck && !multipleMPNCheck) {
      rows.push([
        sku,
        "Stock not found",
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        qty,
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        "Stock not found",
      ]);
      continue;
    }
    if (multipleMPNCheck) {
      const multipleMpnAlternatives = (allProducts || []).filter(
        (product) =>
          product.api_partner_part_number?.toLowerCase()?.includes(partLower) &&
          partLower !== product.api_partner_part_number?.toLowerCase(),
      );
      const status =
        multipleMpnAlternatives.length === 0
          ? "No MPN found."
          : `Show ${multipleMpnAlternatives.length} MPN`;
      rows.push([
        sku,
        status,
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        qty,
        emptyCell,
        emptyCell,
        emptyCell,
        emptyCell,
        multipleMpnAlternatives.length === 0 ? "No MPN found." : status,
      ]);
      continue;
    }
    rows.push([
      sku,
      "Processing",
      emptyCell,
      emptyCell,
      emptyCell,
      emptyCell,
      qty,
      emptyCell,
      emptyCell,
      emptyCell,
      emptyCell,
      "Processing",
    ]);
  }
  return rows;
};

export const convertRmbToUsd = (rmbPrice) => {
  const RMB_TO_USD_RATE = 0.1438;
  const rmb = parseFloat(rmbPrice);
  if (Number.isNaN(rmb) || rmb < 0) return 0;
  return Number((rmb * RMB_TO_USD_RATE).toFixed(4));
};

/** Normalize BomAI product to SearchPage-shaped fields (api_partner, manufacturer, availability, price.min_order, price.multiple) */
export const normalizeBomAiProduct = (p) => {
  console.log({ p });
  const product = {
    ...p,
    api_partner: p.supplier_name ?? p.api_partner ?? "",
    manufacturer: p.brand ?? p.manufacturer ?? "",
    availability: p.availability ?? 999999,
    currency: "USD",
    price: {
      ...p.price,
      min_order: p.moq ?? p.price?.min_order ?? 1,
      multiple: p.qty_step ?? p.price?.multiple ?? 1,
      price_list: (p.price?.price_list ?? []).map((slab) => ({
        ...slab,
        currency: "USD",
        price: p.currency === "RMB" ? convertRmbToUsd(slab.price) : slab.price,
        display_price:
          p.currency === "RMB" ? convertRmbToUsd(slab.display_price) : slab.display_price,
      })),
    },
  };
  console.log({ product });
  return product;
};
